jQuery(function() {
	handleCartUpdate();
  	handleCartRemove();
  	handleAddToCart();
  	handleThreePhaseHover();
  	handleTabs();
  	initHomeSlickCarousel();
});

function initHomeSlickCarousel() {
    jQuery('.slick-slider-home').slick({
        slidesToScroll: 1,
        rows: 0,
        slidesToShow: 1,
        dots: false,
        arrows : false,
        autoplay: true,
        autoplaySpeed: 7000,
        pauseOnFocus: false,
        pauseOnHover: false,
        adaptiveHeight: true
    });
}
       
function handleTabs(){
	//Tabs functionality
    //Firstly hide all content divs
    $('.more-block div.tab-content').hide();
    //Then show the first content div
    $('.more-block div.tab-content:first').show();
    //Add active class to the first tab link
    $('.more-block ul#tabs li:first').addClass('active');
    //Functionality when a tab is clicked
    $('.more-block ul#tabs li a').click(function(){
    	//Firstly remove the current active class
        $('.more-block ul#tabs li').removeClass('active');
        //Apply active class to the parent(li) of the link tag
        $(this).parent().addClass('active');
        //Set currentTab to this link
        var currentTab = $(this).attr('href');
        //Hide away all tabs
        $('.more-block div.tab-content').hide();            
        //show the current tab
        $(currentTab).show();
        //Stop default link action from happening
        return false;
    });	
}
function handleCartUpdate(){
  	jQuery('.checkout-table .jcf-number .jcf-real-element').change(function(){
  	  	showCartLoading('.cart');
      	var that = jQuery(this);
  	  	CartJS.updateItem(jQuery(this).data('index'), jQuery(this).val(), {}, {
  	  		// Define a success callback to display a success message.
  	  	    "success": function(data, textStatus, jqXHR) {
              	reBuildCart('.cart');
  	  	    },
		
  	  	    // Define an error callback to display an error message.
  	  	    "error": function(jqXHR, textStatus, errorThrown) {
  	  	        alert('Failed to update cart, please try again.');
  	  	      	hideCartLoading('.cart');
  	  	    }
  	  	});
  	});
}

function handleCartRemove(){
  	jQuery('.cart-remove').click(function(e){
      	e.preventDefault();
  		showCartLoading('.cart');
      	var that = jQuery(this);
  	  	CartJS.removeItem(jQuery(this).data('index'), {
  	  		// Define a success callback to display a success message.
  	  	    "success": function(data, textStatus, jqXHR) {
              	reBuildCart('.cart');
  	  	    },
		
  	  	    // Define an error callback to display an error message.
  	  	    "error": function(jqXHR, textStatus, errorThrown) {
  	  	        alert('Failed to remove from cart, please try again.');
  	  	      	hideCartLoading('.cart');
  	  	    }
  	  	});
  	
  	});
}

function handleAddToCart(){
  	$('#addtobag').click(function(e){
      e.preventDefault();
      showCartLoading('.product');
      var id = $(this).data('id');
      var quantity = $('#product-choose-quantity').val();
      CartJS.addItem(id, quantity, {}, {
  			// Define a success callback to display a success message.
  		    "success": function(data, textStatus, jqXHR) {
              	reBuildCart('.product');
              	openCart();
  		    },
		
  		    // Define an error callback to display an error message.
  		    "error": function(jqXHR, textStatus, errorThrown) {
  		        alert('Failed to add to cart, please try again.');
              	hideCartLoading('.product');
  		    }
  		});
    });
}

function showCartLoading(where){
	jQuery(where + '.cart-loading-mask').css('display', 'flex');
}

function hideCartLoading(where){
	jQuery(where + '.cart-loading-mask').hide();
}

function reBuildCart(where){
  	jQuery.getJSON('/cart.js', function(cart) {
      	if(cart.item_count > 0){
      		// remove existing cart form
      		jQuery('.cart-form').remove();
          	jQuery('#cart-empty').remove();
          
          	// add cart form
          	var html = '<form action="/cart" method="post" class="cart-form"><div class="cart cart-loading-mask"><img src="//cdn.shopify.com/s/files/1/0274/6009/t/6/assets/cart-loading.gif"></div><table class="checkout-table"><tbody>';
      	
      		// generate new cart items within cart form
      		jQuery.each(cart.items, function( index, item ) {
    		  	html += '<tr><td><a href="' + item.url + '"> <img src="' + item.image + '" alt=""> </a></td> <td> <a href="' + item.url + '" class="name">' + item.title + '</a><dl><dd><span class="money">$' + (item.discounted_price/100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' AUD</span></dd><dt>qty</dt><dd> <input data-index="' + (index+1) + '" type="number" min="1" value="' + item.quantity + '"><a data-index="' + (index+1) + '" class="cart-remove" href="#">remove</a></dd></dl></td></tr>';
      	    });
      	
      		// finish cart form
          	html += '</tbody></table><div class="total-box"><dl class="grand cart-total"><dt>subtotal</dt><dd><span class="money">$' + (cart.total_price/100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' ' + cart.currency + '</span></dd></dl></div><div class="link-box"><a href="/collections/all/clothing">continue shopping</a><input type="submit" name="checkout" value="checkout"></div></form>'
      	
            // append cart form
            jQuery('.popup.cart-popup').append(html);
          
      		// re-init functionalities
      		initCustomForms();
      		handleCartUpdate();
  			handleCartRemove();
      	}else{
      		jQuery('.cart-form').remove();
      	  	jQuery('.cart-popup').append('<p style="text-align:center;" id="cart-empty">Empty</p>');
      	}
      
      	// hide loading icon
      	hideCartLoading(where);
	});
}

function openCart(){
	jQuery('.popup-holder.popup-basket').addClass('popup-active');
    jQuery('.popup-holder.popup-basket .cart-popup').css('display', 'block');
    jQuery(document).on('click touchstart', function(e){
    	// hide popup if clicked outside
		var targetNode = $((e.changedTouches ? e.changedTouches[0] : e).target);
		if (!targetNode.closest(jQuery('.popup-holder.popup-basket')).length && !targetNode.closest(jQuery('.popup-holder.popup-basket .open')).length) {
			jQuery('.popup-holder.popup-basket').removeClass('popup-active');
    		jQuery('.popup-holder.popup-basket .cart-popup').css('display', 'none');
		}
    });
}

function handleThreePhaseHover() {

    jQuery('.hover-section').mouseenter(function () {
        jQuery(this).parents('li').find('.main-image').attr('src', jQuery(this).find('img').attr('src'));
        jQuery(this).parents('li').find('a').addClass('hover');
    });

    jQuery('.hover-left, .hover-right, .hover-middle').mouseleave(function () {
        jQuery(this).parents('li').find('.main-image').attr('src', jQuery(this).parents('li').find('.original-img').attr('src'));
        jQuery(this).parents('li').find('a').removeClass('hover');
    });

    jQuery('.hover-section').click(function () {
        if(jQuery(this).is('[data-url]')){
            window.location.href = jQuery(this).data('url');
        }
    });
}

function GetURLParameter(sParam){
	var sPageURL = window.location.search.substring(1);
	var sURLVariables = sPageURL.split('&');
	for (var i = 0; i < sURLVariables.length; i++){
		var sParameterName = sURLVariables[i].split('=');
		if (sParameterName[0] == sParam){
			return sParameterName[1];
		}
	}
}